import Vue from "vue"

import options from "@/data/services/service"
import {serviceAdapter} from "@/adapters/services/service"

let new_options = Vue.prototype.copyObject(options)
new_options.prepareParams = ['id', 'clinic_id']
new_options.adapter = serviceAdapter
export default new_options
